import { render } from "./AppContent.vue?vue&type=template&id=812d1a4e&scoped=true"
import script from "./AppContent.vue?vue&type=script&lang=js"
export * from "./AppContent.vue?vue&type=script&lang=js"

import "./AppContent.vue?vue&type=style&index=0&id=812d1a4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-812d1a4e"

export default script